import clsx from 'clsx'
import icWarning from '../../../assets/images/ic-warning.svg'
import { Button, Modal } from 'avo-ui'

const ModalExport = ({ className, show, onHide, description, totalData, isLoading, onExport }) => {
    return (
        <Modal dialogClassName={'max-w-[328px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <>
                <div className={clsx('flex flex-col space-y-4 items-center p-10 text-neutral-70', className)}>
                    <img src={icWarning} alt={'ic-warning'} className={'w-12 h-12'} />
                    <p className={'font-semibold'}>Export</p>
                    <p className={'text-center'}>{description}</p>
                    <p>Total Data: {totalData}</p>
                </div>
                <div className={'flex flex-row px-6 py-3 border-t space-x-3 justify-center'}>
                    <Button type={'outline'} title={'Cancel'} onClick={onHide} />
                    <Button title={'Export'} loading={isLoading} onClick={onExport} />
                </div>
            </>
        </Modal>
    )
}

export default ModalExport
